import React, { Component } from 'react'
// import TemplateForm from 'components/TemplateForm'
import Wizard from 'components/TemplateForm/Wizard'
import language from 'utils/vast-languagepack'
// import TopButtons from './TopButtons'
import Stepper from './Stepper'
import BottomNav from 'components/TemplateForm/BottomNav'
// TODO: create a prompt for this page

export default class CreateOrEditTemplatePage extends Component {
  state = { loaded: false }

  componentDidMount() {
    const {
      receiveTemplate,
      readTemplate,
      match,
      stepperGoTo,
      template,
      read,
    } = this.props

    console.log('match:', match)

    const templateID = match.params.templateId || this.props.templateID
    const templateType = match?.params?.templateType

    const readFunc = () =>
      templateType === 'sms'
        ? read(templateID, 'sms/template').then(payload => {
            receiveTemplate({ ...payload, type: 'sms' })
            this.setState({ loaded: true })
            stepperGoTo(1, 'template')
          })
        : readTemplate(templateID).then(payload => {
            receiveTemplate({ ...payload, type: 'email' })
            this.setState({ loaded: true })
            stepperGoTo(1, 'template')
          })

    if (templateID === 'new') {
      receiveTemplate(null)
      stepperGoTo(0, 'template')
    } else if (templateID === 'preload') {
      console.log('preloaded')
    } else {
      if (template) {
        Promise.resolve(
          receiveTemplate({ ...template, type: templateType }),
        ).then(() => readFunc())
      } else {
        readFunc()
      }
    }
  }

  componentWillUnmount() {
    this.setState({ loaded: false })
    this.props.receiveTemplate(null)
    this.props.stepperGoTo(0, 'template')
  }

  render() {
    const { templateID, template } = this.props
    if (template || templateID === 'new') {
      return (
        <div
          className={this.props.classes.content}
          style={{ height: 'calc(100% - 60px)' /* , padding: '60px 24px 0' */ }}
        >
          <Stepper />
          {/* {templateID === 'new' ? (
            <Wizard />
          ) : (
            <TemplateForm history={history} />
          )} */}
          <Wizard />
          <BottomNav />
        </div>
      )
    }

    return (
      <div className={this.props.classes.content}>
        {language.templatePage.viewAll.loading}
      </div>
    )
  }
}
